// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    PostIntelligentPartnerTaskInfosQualityFindAllBody,
    BaseResponseListQualityIntelligentPartnerTaskStatisticsFoundResponse,
} from '../../../types';

/**
 * 获取质培列表
 *
 * @export
 * @tags 智能陪练发布任务接口
 * @link [POST] /intelligentPartnerTaskInfos/quality/findAll
 */
export function postIntelligentPartnerTaskInfosQualityFindAll(
    data: PostIntelligentPartnerTaskInfosQualityFindAllBody
): Promise<BaseResponseListQualityIntelligentPartnerTaskStatisticsFoundResponse>;
export function postIntelligentPartnerTaskInfosQualityFindAll(
    data: PostIntelligentPartnerTaskInfosQualityFindAllBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseListQualityIntelligentPartnerTaskStatisticsFoundResponse>;
export function postIntelligentPartnerTaskInfosQualityFindAll(
    data: PostIntelligentPartnerTaskInfosQualityFindAllBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseListQualityIntelligentPartnerTaskStatisticsFoundResponse> {
    return request<PostIntelligentPartnerTaskInfosQualityFindAllBody, never, never>(
        '/intelligentPartnerTaskInfos/quality/findAll',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postIntelligentPartnerTaskInfosQualityFindAll',
        }
    );
}

export const meta = [
    {
        tags: ['智能陪练发布任务接口'],
        path: '/intelligentPartnerTaskInfos/quality/findAll',
        method: 'post',
    },
];
